/**
 * Money / date / pct formatters — small pure helpers shared across pages.
 *
 * Money is stored as `amount_cents: number` everywhere (per ADR-0002 +
 * checkoutClient.ts JSDoc Q3 unilateral resolution). Display uses
 * Colombian Peso convention.
 */

const COP = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

export function formatCOP(cents: number | null | undefined): string {
  if (cents === null || cents === undefined || !Number.isFinite(cents)) {
    return 'Consultar';
  }
  return COP.format(cents);
}

export function formatPct(value: number | null | undefined, fractionDigits = 0): string {
  if (value === null || value === undefined || !Number.isFinite(value)) return '—';
  return `${value.toFixed(fractionDigits)}%`;
}

export function formatEventDate(iso: string | null | undefined): string {
  if (!iso) return 'Fecha por confirmar';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return 'Fecha por confirmar';
  return new Intl.DateTimeFormat('es-CO', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(d);
}
